'use strict';

/**
 * SyncError - An error object for model syncronization errors
 */
export default class SyncError extends Error {

    /**
     * constructor
     * @constructor
     * @param  {external:Backbone.Model} model - The model that was being sync'd
     * @param  {external:jqXhr} response - An XHR object
     * @param  {object} options - A Backbone-style options object
     * @return {SyncError}
     */
    constructor(model, response, options) {
        if (typeof response === 'string') {
            super(response.error);
        } else {
            super();
        }

        this.stack = new Error().stack;
        this.name = this.constructor.name;

        this.model = model;
        this.collection = model;
        this.response = response;
        this.options = options;
        const error = (response || {}).error;
        this.status = (error ? error.status : 0) || 500;

        if (response.error instanceof Array) {
            this.messages = response.error.map((err) => err.message);
        } else {
            this.messages = [response.error.message || 'Unknown error'];
        }

        return this;
    }
}



// WEBPACK FOOTER //
// ./app/errors/sync-error.js